// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"8cf4dcc3","161":"98692e5d","198":"9b2afa3c","239":"c814c67a","703":"dd222d96","787":"9e9f4ffd","879":"f561bd67"}[chunkId] + ".chunk.js";
};